export enum GeoRestrictedPage {
  GAMES = "/games",
  ALL_BONUSES = "/all-bonuses",
  TOURNAMENTS_LOBBY = "/tournaments/[tournamentId]/lobby",
}

export const GeoRestrictedPages = [GeoRestrictedPage.GAMES, GeoRestrictedPage.TOURNAMENTS_LOBBY];

export const GeoModalText = {
  [GeoRestrictedPage.GAMES]: {
    text: "Due to regulations in your country, we are unable to offer access to games.",
    title: "Sorry, Games Are Not Available In Your Region",
  },
  [GeoRestrictedPage.ALL_BONUSES]: {
    text: `Due to regulations in your country, we are unable to display bonus offers. If you believe this is wrong, contact us or consider using a VPN.`,
    title: "Sorry, Bonuses Are Not Available In Your Region",
  },
  [GeoRestrictedPage.TOURNAMENTS_LOBBY]: {
    text: "Tournament lobbies are unavailable in your region.",
    title: "Sorry, Tournament Lobbies Are Not Available In Your Region",
  },
};
